<div class="crusher-data-section">
  <h4>Crusher Data Import</h4>
  <p class="text-muted">Import the latest CSV. New columns are detected automatically.</p>

  <input
    type="file"
    id="csv-file-input"
    accept=".csv"
    (change)="onFileSelected($event)"
    hidden
  />

  <button
    class="btn btn-primary"
    [disabled]="isUploading() || isPreviewing()"
    (click)="triggerFileInput()"
  >
    @if (isPreviewing()) {
      <span class="spinner-border spinner-border-sm me-1" role="status"></span>
      <span>Analyzing…</span>
    } @else if (isUploading()) {
      <span class="spinner-border spinner-border-sm me-1" role="status"></span>
      <span>Uploading…</span>
    } @else {
      <i class="fas fa-upload me-1"></i>Upload CSV
    }
  </button>

  @if (isUploading()) {
    <div class="progress mt-3">
      <div
        class="progress-bar progress-bar-striped progress-bar-animated"
        role="progressbar"
        [style.width.%]="progress()"
        [attr.aria-valuenow]="progress()"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        {{ progress() }}%
      </div>
    </div>
  }

  @if (result(); as r) {
    <div class="import-result mt-3">
      <div class="alert alert-success d-flex align-items-center gap-2">
        <i class="fas fa-check-circle fs-5"></i>
        <span>Import completed successfully</span>
      </div>
      <div class="import-stats">
        <div class="stat-row">
          <span class="stat-label">Rows analysed</span>
          <span class="stat-value">{{ r.totalRows }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">New rows inserted</span>
          <span class="stat-value text-success">{{ r.inserted }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Rows updated</span>
          <span class="stat-value text-info">{{ r.updated }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Rows already existed</span>
          <span class="stat-value text-muted">{{ r.alreadyExisting }}</span>
        </div>
        @if (r.columnsAdded.length > 0) {
          <div class="stat-row">
            <span class="stat-label">New columns added</span>
            <span class="stat-value text-warning">{{ r.columnsAdded.length }}</span>
          </div>
        }
      </div>
      @if (r.columnsAdded.length > 0) {
        <div class="alert alert-info mt-2 mb-0">
          <strong>New columns created:</strong>
          <code class="ms-1">{{ r.columnsAdded.join(', ') }}</code>
        </div>
      }
      @if (r.errors && r.errors.length > 0) {
        <div class="alert alert-warning mt-2 mb-0">
          <strong>Warnings:</strong>
          <ul class="mb-0 mt-1">
            @for (err of r.errors; track err) {
              <li>{{ err }}</li>
            }
          </ul>
        </div>
      }
    </div>
  }

  @if (error(); as err) {
    <div class="alert alert-danger mt-3 d-flex align-items-center gap-2">
      <i class="fas fa-times-circle fs-5"></i>
      <span>{{ err }}</span>
    </div>
  }
</div>
